import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderMaterialsFacade } from './shipment-transport-order-materials.facade';
import { ShipmentTransportOrderMaterialListSearchCriteria } from '../../models/shipment-transport-order-materials.model';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderMaterialsGuard {
  constructor(private shipmentTransportOrderMaterialsFacade: ShipmentTransportOrderMaterialsFacade) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(
      this.shipmentTransportOrderMaterialsFacade,
      new ShipmentTransportOrderMaterialListSearchCriteria(),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderMaterialsFacade);
  }
}
